<template>
	<div>
		<aside class="main-sidebar">
			<section class="sidebar" style="height: auto">
				<div @click="$refs.UserDataUpload.open()" class="user-panel">
					<div class="iniciais">{{ breve }}</div>
					<div class="pull-left info">
						<p>
							{{ user_data.uid.nome }}
							{{ user_data.uid.sobrenome }}
						</p>
						<a class="cnt-status"> {{ user_data.uid.funcao }} </a>
					</div>
				</div>

				<!-- <div class="sidebar-form">
  				<div class="input-group">
  					<input type="text"
  						v-model='search' class="form-control" placeholder="Pesquisar..."
  					>
  					<span class="input-group-btn">
  						<button class="btn btn-flat">
  							<i class="fa fa-search"></i>
  						</button>
  					</span>
  				</div>
  			</div> -->

				<ul v-if="MenuItens != null" class="sidebar-menu tree">
					<li class="header">MAIN NAVIGATION</li>
					<ItemAside
						v-for="(item, id) in MenuItens"
						:key="id"
						:title="item.text"
						:link="item.link"
						:icon="item.icon"
						:childs="item.childs"
						:hash="item.hash"
						:openAll="openAll"
						:opened="opened"
						@clkme="(val) => (opened = val)"
					/>
					<ItemAside
						title="Sair"
						link=""
						icon="sign-out"
						@click="logout"
					/>
				</ul>
				<ul v-else class="sidebar-menu tree">
					<li class="header">
						<i class="fa fa-spin fa-spinner"></i>
						Carregando...
					</li>
				</ul>

				<div class="clearfix"></div>
			</section>
		</aside>
		<user-data-update ref="UserDataUpload" :assets="assets" />
	</div>
</template>
<script>
	import ItemAside from './item.aside.vue';
	import { mapState } from 'vuex';
	import WBS from 'js/http';
	import { clone } from 'lodash';
	import MenuItens from './mapMenu.js';
	import UserDataUpdate from './userDataUpdate.vue';
	import toastr from 'toastr';

	export default {
		name: 'AppAside',
		components: { ItemAside, UserDataUpdate },
		data() {
			return {
				opened: '',
				MenuItens: null,
				openAll: false,

				assets: {
					perfis: [],
					departamentos: [],
				},
			};
		},
		computed: {
			...mapState(['user_data']),
			breve() {
				let all_name =
					this.user_data.uid.nome +
					' ' +
					this.user_data.uid.sobrenome;
				all_name = all_name.split(' ');
				return all_name[0][0] + (all_name[1][0] || '');
				// console.log()
			},
		},
		watch: {
			search: function (val) {
				if (val != '') this.openAll = true;
				else this.openAll = false;
			},
		},
		methods: {
			logout() {
				this.$store.commit('LOGOUT');
				this.$router.push('/login');
			},
		},
		mounted() {
			$('.main-sidebar').hover(
				(e) => {
					if ($('body').hasClass('sidebar-collapse')) {
						$('body').removeClass('sidebar-collapse');
						$('body').addClass('sidebar-expanded-on-hover');
					}
				},
				(e) => {
					if ($('body').hasClass('sidebar-expanded-on-hover')) {
						$('body').removeClass('sidebar-expanded-on-hover');
						$('body').addClass('sidebar-collapse');
					}
				}
			);

			WBS.send('private-read-smartTables', (resp) => {
				let sTables = [];
				if (resp.status == 'success') {
					if (resp.data == undefined) {
						this.sTables = clone(reset);
					} else if (resp.data.length > 0) {
						let baseUrls = [
							//   {link: "/exames",     text: "Exames",           hash:"02ddd45060a798d1b0fdcb96185a753d"},
							{ link: '/tables/create', text: 'Nova Tabela' },
							// {link: "/pessoas",    	  text: "Pessoas",          hash:"02ddd45060a798d1b0fdcb96185a753d"},
							{
								link: '/navios',
								text: 'Navios',
								hash: '02ddd45060a798d1b0fdcb96185a753d',
							},
							{
								link: '/tipo_exame',
								text: 'Tipos de Exame',
								hash: '02ddd45060a798d1b0fdcb96185a753d',
							},
							{
								link: '/tipo_vacina',
								text: 'Tipos de Vacinas',
								hash: '02ddd45060a798d1b0fdcb96185a753d',
							},
							{
								link: '/status_vacinacao',
								text: 'Status Vacinacao',
								hash: '02ddd45060a798d1b0fdcb96185a753d',
							},
							{
								link: '/passaporte',
								text: 'Passaporte',
								hash: '02ddd45060a798d1b0fdcb96185a753d',
							},
							{
								link: '/resultados',
								text: 'Resultados',
								hash: '02ddd45060a798d1b0fdcb96185a753d',
							},
							{
								link: '/cargo',
								text: 'Cargo',
								hash: '02ddd45060a798d1b0fdcb96185a753d',
							},
							{
								link: '/local_exame',
								text: 'Local de Exame',
								hash: '02ddd45060a798d1b0fdcb96185a753d',
							},
						];

						sTables.push(...baseUrls);
						resp.data.forEach((item) => {
							sTables.push({
								link: '/tables/' + item.id,
								text: item.titulo,
							});
						});
					}
				}
				let mountMenu = JSON.parse(JSON.stringify(MenuItens));
				if (sTables.length > 0) {
					let index = mountMenu.findIndex(
						(item) =>
							item.hash == '37398e0d87d33c912d3fbe125f4f10ed'
					);
					mountMenu[index].childs = sTables;
				}
				this.MenuItens = mountMenu;
			});

			WBS.send('protected-read-AssetsUsers', (resp) => {
				if (resp.status == 'success') {
					this.assets.perfis = resp.data.perfis;
					this.assets.departamentos = resp.data.departamentos;
				} else {
					toastr.error(resp.msgs[0]);
					console.log(resp);
				}
			});
		},
	};
</script>
<style scoped>
	.skin-green .sidebar-menu > li.header {
		color: #ffffff;
		background: #a22a00;
	}

	.skin-green .sidebar-form {
		border: 1px solid #d04312;
	}
	.sidebar-form input[type='text'],
	.sidebar-form .btn {
		background-color: #d04312;
	}

	.main-sidebar {
		height: calc(100vh) !important;
		overflow-y: auto !important;
	}
	.user-panel {
		/*padding: 15px 10px 60px 10px !important;*/
		cursor: pointer;
	}

	.user-panel:hover {
		background-color: #fb7c50;
	}

	.info p {
		color: #f9f6fd !important;
		margin-bottom: 4px !important;
		margin-top: 4px !important;
	}
	.info .cnt-status {
		color: #c3abf1 !important;
	}
	.iniciais {
		float: left !important;
		width: 50px !important;
		height: 50px !important;
		background-color: #d04312 !important;
		border-radius: 60px !important;
		text-align: center !important;
		font-size: 15px !important;
		font-weight: 600 !important;
		padding: 15px 0 !important;
		color: #f9f6fd !important;
	}
	.sidebar-collapse .iniciais {
		width: 40px !important;
		height: 40px !important;
		line-height: 13px !important;
	}
	.sidebar-collapse .user-panel {
		padding: 15px 3px 60px 3px !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/cnt-app/components/aside.vue